<template>
  <v-row no-gutters align="center">
    <v-col cols="6" class="text-left filter-text pb-2">
      {{ $i18n.t(translationPath) }}
    </v-col>
    <v-col cols="6" class="text-left">
      <data-input v-model="switcherModel" :data-type="dataType" @change="toggleFilter" />
    </v-col>
  </v-row>
</template>

<script>
import DataInput from '@/components/DataInput';

export default {
  name: 'SidebarSwitcherFilter',
  components: {
    DataInput,
  },
  props: {
    name: {
      type: String,
    },
    translationPath: {
      type: String,
    },
    filter: {
      type: Object,
      required: true,
    },
    emptyFilter: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    switcherModel: false,
    dataType: {
      name: 'switch',
    },
  }),
  methods: {
    toggleFilter(value) {
      if (value) {
        this.$root.$emit('setAdditionalTableFilterValues', this.filter);
      } else {
        this.$root.$emit('setAdditionalTableFilterValues', this.emptyFilter);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filter-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #202124;
}
</style>
